import { render, staticRenderFns } from "./customTagDialog.vue?vue&type=template&id=a5c1e238"
import script from "./customTagDialog.vue?vue&type=script&lang=js"
export * from "./customTagDialog.vue?vue&type=script&lang=js"
import style0 from "./customTagDialog.vue?vue&type=style&index=0&id=a5c1e238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports